module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[15]136.6a8530a.woff2";